/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:30:13
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-02 15:47:47
 */
import {
  CaretDownOutlined,
  CaretUpOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Layout, Menu } from "antd";
import React, { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, Redirect, Route, Switch, useLocation } from "react-router-dom";
import { CREDENTIALS_KEY, Logout } from "../app/appSlice";
import Icon from "../components/icon/Icons";
import { RecordsCenterLayout } from "../features/RecordsCenterLayout/RecordsCenterLayout";
import { SystemLayout } from "../features/SystemLayout/SystemLayout";
import styles from "./DafaultLayout.module.css";
import { StatementLayout } from "../features/statementLayout/statementLayout";

const { Header } = Layout;
export const DefaultLayout = (): ReactElement => {
  const dispatch = useDispatch();

  const location = useLocation();

  const [overlayVisible, setOverlayVisible] = useState(false);

  const [selectedKey, setSelectedKey] = useState("datacenter");

  const [userName, setUserName] = useState("admin");

  useEffect(() => {
    const status = JSON.parse(localStorage.getItem(CREDENTIALS_KEY) as string);
    setUserName(status.userName);
  }, []);

  useEffect(() => {
    const paths = location.pathname.split("/");
    if (paths.length >= 2) {
      const main = paths[1];
      if (
        ["provinceDataCenter", "datacenter", "statement", "system"].includes(
          main
        )
      ) {
        setSelectedKey(main);
      }
    }
  }, [location]);

  const overlay = (
    <Menu style={{ marginRight: "20px" }}>
      <Menu.Item
        className={styles.overlay}
        onClick={() => {
          dispatch(Logout(0));
        }}
      >
        <LogoutOutlined />
        退出登录
      </Menu.Item>
    </Menu>
  );
  return (
    <Layout style={{ width: "100%", height: "100%" }}>
      <Header
        style={{
          background: "#027AFF",
          display: "flex",
          justifyContent: "space-between",
          padding: "0",
        }}
      >
        <div className={styles.logo}>
          <Button
            type='text'
            style={{
              width: 260,
              display: "flex",
              alignItems: "center",
              color: "#fff",
              height: "100%",
              fontSize: "20px",
              fontWeight: "bolder",
            }}
            icon={
              <Icon
                style={{ fill: "#fff", marginRight: "20px" }}
                icon='logo'
                mode='large'
              />
            }
          >
            浙江省
          </Button>
        </div>
        <Menu
          theme='dark'
          style={{
            background: "#027AFF",
            color: "#fff",
            fontSize: "16px",
            flex: "1",
          }}
          mode='horizontal'
          defaultSelectedKeys={["home"]}
          selectedKeys={[selectedKey]}
          onSelect={({ key }) => {
            setSelectedKey(key as string);
          }}
        >
          <Menu.Item key='home'>
            <Link to='/'>首页</Link>
          </Menu.Item>
          <Menu.Item key='datacenter'>
            <Link to='/datacenter'>数据中心</Link>
          </Menu.Item>
          <Menu.Item key='statement'>
            <Link to='/statement'>数据分析</Link>
          </Menu.Item>
          <Menu.Item key='system'>
            <Link to='/system'>系统管理</Link>
          </Menu.Item>
          <span style={{ float: "right", fontSize: "14px" }}>
            诊疗行为监督在线
          </span>
        </Menu>
        <Dropdown
          className={styles.user}
          overlay={overlay}
          visible={overlayVisible}
          onVisibleChange={(visible) => setOverlayVisible(visible)}
        >
          <Button
            type='text'
            size='large'
            style={{ color: "#fff", height: "100%" }}
            icon={<UserOutlined />}
          >
            {`${userName} `}
            {overlayVisible ? <CaretUpOutlined /> : <CaretDownOutlined />}
          </Button>
        </Dropdown>
      </Header>
      <Layout>
        <Switch>
          <Route path='/datacenter'>
            <RecordsCenterLayout />
          </Route>
          <Route path='/statement'>
            <StatementLayout />
          </Route>
          <Route path='/system'>
            <SystemLayout />
          </Route>
          <Redirect from='/' to='/datacenter' />
        </Switch>
      </Layout>
    </Layout>
  );
};
